export default __webpack_public_path__ + "static/media/folder_icon.d9362600.svg";